import { OwnershipStatusIndicator } from '@internal/backstage-plugin-common-library-react';
import React from 'react';

import {
  IconLinkVerticalProps,
  InfoCardVariants,
} from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import { AboutCard } from '../Components/AboutCard';

export const JiraTeamAboutCard = (props: { variant?: InfoCardVariants }) => {
  const { entity } = useEntity();

  const teamId = entity.metadata.annotations?.['tomtom.com/jira-team-id'];
  const ownerRaw = entity.spec?.owner;
  const ownerRef =
    typeof ownerRaw === 'string' ? ownerRaw.trim().toLocaleLowerCase() : '';
  let normalizedOwnerRef = '';
  if (ownerRef) {
    normalizedOwnerRef = ownerRef.includes(':')
      ? ownerRef
      : `group:default/${ownerRef}`;
  }
  const hasConfirmedOwner = Boolean(
    normalizedOwnerRef && normalizedOwnerRef !== 'group:default/unknown',
  );
  const ownershipLink: IconLinkVerticalProps[] = [
    {
      label: hasConfirmedOwner
        ? 'Ownership confirmed'
        : 'Ownership not confirmed',
      icon: <OwnershipStatusIndicator isConfirmed={hasConfirmedOwner} />,
      disabled: true,
    },
  ];

  const jiraOrgId = '94231b6b-6aab-4e2a-b37b-36b1dba2de0b';
  const jiraLink = teamId
    ? `https://home.atlassian.com/o/${jiraOrgId}/people/team/${teamId}`
    : null;

  const jiraLinks: IconLinkVerticalProps[] = jiraLink
    ? [
        {
          label: 'Jira',
          icon: <OpenInNewIcon />,
          href: jiraLink,
          disabled: false,
        },
      ]
    : [];

  const additionalLinks: IconLinkVerticalProps[] = [
    ...ownershipLink,
    ...jiraLinks,
  ];

  return (
    <AboutCard
      variant={props.variant || 'gridItem'}
      hideSourceLinks
      hideTechDocsLinks
      additionalSubHeaderLinks={additionalLinks}
    />
  );
};
